import { useQuery } from "@tanstack/react-query";
import { Activity } from "lucide-react";
import { opsApi } from "@/features/operations/api";

export default function AdminActivity() {
    const { data, isLoading } = useQuery({
        queryKey: ["admin", "activity"],
        queryFn: () => opsApi.listActivity(1, 100),
    });

    return (
        <div data-testid="admin-activity-page" className="space-y-6">
            <header>
                <h1 className="text-2xl font-extrabold">Activity log</h1>
                <p className="text-sm text-muted-foreground">
                    Audit trail of every admin action across the network.
                </p>
            </header>
            {isLoading ? (
                <p>Loading…</p>
            ) : !data?.items.length ? (
                <div className="rounded-2xl border border-dashed bg-white p-10 text-center">
                    <Activity className="mx-auto mb-3 h-8 w-8 text-muted-foreground" />
                    <p className="text-sm text-muted-foreground">No activity recorded yet.</p>
                </div>
            ) : (
                <ul className="space-y-2">
                    {data.items.map((row) => (
                        <li
                            key={row.id}
                            data-testid={`admin-activity-${row.id}`}
                            className="flex flex-wrap items-baseline gap-3 rounded-xl border border-border/60 bg-white px-4 py-3 text-sm"
                        >
                            <span className="font-mono text-xs text-muted-foreground">
                                {new Date(row.at).toLocaleString()}
                            </span>
                            <span className="rounded bg-brand/10 px-2 py-0.5 text-xs font-bold text-brand">
                                {row.actor_role}
                            </span>
                            <span className="font-semibold">{row.actor_email}</span>
                            <span className="text-muted-foreground">→</span>
                            <span className="font-mono text-xs">{row.action}</span>
                            {row.target && (
                                <span className="text-xs text-muted-foreground">
                                    ({row.target.slice(0, 24)})
                                </span>
                            )}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
